import AuthenticationHandler from './authentication';
import DashboardHandler from './dashboard';
import InstrumentsHandler from './instruments';
import UsersHandler from './users';
import YardsHandler from './yards';

export default [
  ...AuthenticationHandler,
  ...DashboardHandler,
  ...InstrumentsHandler,
  ...UsersHandler,
  ...YardsHandler,
];
